module.exports = __webpack_public_path__ + "static/media/3.db3b7e4f.png";